<template>
  <v-snackbar
    v-model="snackVisible"
    :timeout="2000"
    :timer="true"
    :text="snackMessage"
    :color="snackType"
  />
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import { useErrorStore } from '@/stores/errors.ts';

const store = useErrorStore();
const { snackMessage, snackType, snackVisible } = toRefs(store);
</script>
